import moment from 'moment-timezone';

const EASTERN = 'US/Eastern';

/**
 * Job / invoice DATETIME fields stored as Eastern wall-clock:
 * UTC components in the ISO string equal the Eastern display digits
 * (including order.created_at, date, expired, order_end_date).
 * Format with UTC so moment.tz.setDefault('US/Eastern') does not shift −4/−5h.
 *
 * Use formatInstantEastern only when the value is a real UTC instant
 * (e.g. some audit timestamps that are not wall-clock DATETIME).
 */
export function formatWallClockDate(date, format = 'MM/DD/YY hh:mm a') {
  if (date == null || date === '') {
    return '';
  }
  const m = moment.utc(date);
  if (!m.isValid()) {
    return '';
  }
  return m.format(format);
}

/**
 * Wall-clock values that are often date-only at 00:00:00 (invoice.date,
 * order_end_date). Hide a fake midnight / 8pm so the UI is not confusing.
 */
export function formatWallClockDateSmart(
  date,
  {
    withTime = 'MM/DD/YY hh:mm a',
    dateOnly = 'MM/DD/YY',
  } = {},
) {
  if (date == null || date === '') {
    return '';
  }
  const m = moment.utc(date);
  if (!m.isValid()) {
    return '';
  }
  if (m.hour() === 0 && m.minute() === 0 && m.second() === 0) {
    return m.format(dateOnly);
  }
  return m.format(withTime);
}

/** Real UTC/server instants → Eastern wall display. */
export function formatInstantEastern(date, format = 'MM/DD/YY hh:mm a') {
  if (date == null || date === '') {
    return '';
  }
  const m = moment(date).tz(EASTERN);
  if (!m.isValid()) {
    return '';
  }
  return m.format(format);
}
